import { render, staticRenderFns } from "./_base-hero-background.vue?vue&type=template&id=1d3a0087&scoped=true"
import script from "./_base-hero-background.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-hero-background.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-hero-background.vue?vue&type=style&index=0&id=1d3a0087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3a0087",
  null
  
)

export default component.exports